<script lang="ts">
  import { cn } from '$lib/utils';

  // eslint-disable-next-line no-undef
  type T = $$Generic<string>;

  let className: undefined | string = undefined;
  export { className as class };

  export let label: string;
  export let group: undefined | T = undefined;
  export let value: undefined | T = undefined;
  export let variant: 'default' | 'ghost' = 'default';
  export let selectedBackgroundColor: string | undefined = undefined;
  export let selectedTextColor: string | undefined = undefined;
</script>

<div
  class={cn('grid h-10 place-items-center', className)}
  style:--selectedBackgroundColor={selectedBackgroundColor}
  style:--selectedTextColor={selectedTextColor}
>
  <input
    type="radio"
    bind:group
    {value}
    on:change
    on:mouseenter
    on:mouseleave
    on:click
    on:focus
    on:blur
    {...$$restProps}
    class={cn(
      'invisible visually-hidden  [&:disabled+label]:cursor-not-allowed [&:disabled+label]:select-none [&:disabled+label]:opacity-40 [&:focus-visible+label]:ring',
      selectedBackgroundColor && selectedTextColor
        ? '[&:checked+label:hover]:bg-[--selectedBackgroundColor] [&:checked+label]:border-[--selectedBackgroundColor] [&:checked+label]:bg-[--selectedBackgroundColor] [&:checked+label]:text-[--selectedTextColor]'
        : '[&:checked+label:hover]:bg-accent [&:checked+label]:border-accent [&:checked+label]:bg-accent [&:checked+label]:text-highlight'
    )}
  />
  <label
    for={$$restProps.id}
    class={cn(
      'text-sm px-2.5 py-2 bg-highlight/64 hover:bg-highlight cursor-pointer rounded-sm',
      variant === 'default' &&
        'border border-transparent shadow-none transition-all duration-300 motion-reduce:transition-none',
      variant === 'ghost' &&
        'border border-primary/14 shadow-none transition-all duration-300 motion-reduce:transition-none'
    )}
  >
    {label}
  </label>
</div>
